import React from 'react';
import Topbar from './topbar';
import LogoSearch from './LogoSearch';
import Navbar from './Navbar';
import Branch from '../../../models/branch.model';

interface Props {
  branch?: Branch | undefined
}

const Header: React.FC<Props> = ({ branch }) => {

  return (
    <>
      <header className="ecn-header">
        <Topbar />
        <LogoSearch branch={branch} isMainSite={true} />
        <Navbar />
      </header>
    </>
  );
}

export default Header;